import logoVariants from '@/assets/img/logo';
import { Center, Image } from '@chakra-ui/react';
import React from 'react';

const OrganizationLogo = ({
  logoUrl,
  logoSize,
  rounded,
}: {
  logoUrl?: string;
  logoSize?: number;
  rounded?: boolean;
}) => {
  return logoUrl ? (
    <Image
      alt="user-avatar-wellness"
      width={`${logoSize}px`}
      maxHeight={`${logoSize}px`}
      src={logoUrl}
      style={{ objectFit: 'cover', borderRadius: rounded ? '50%' : undefined }}
    />
  ) : (
    <Center
      borderRadius={'50%'}
      border={'5px solid white'}
      boxShadow={'0px 4px 8px 0px #0E00621A'}
      width={`${logoSize}px`}
      height={`${logoSize}px`}
      backgroundColor={'primary.100'}
    >
      <Image src={logoVariants.purpleNoText112x112op50pct} width={'30px'} height={'30px'} alt="my-omnia-logo" />
    </Center>
  );
};

export default OrganizationLogo;
